import { render } from "./ThankYouPage.vue?vue&type=template&id=7b18afa6"
import script from "./ThankYouPage.vue?vue&type=script&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&lang=js"

import "./ThankYouPage.vue?vue&type=style&index=0&id=7b18afa6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__